<template>
  <div>
    <div class="d-flex bd-b mg-b-10">
      <label
        class="tx-sans tx-11 tx-semibold tx-uppercase tx-color-01 tx-spacing-1"
        >Шүүх</label
      >
      <span class="mg-l-auto tx-11">{{ tasks.length }}/{{ allCount }}</span>
    </div>

    <form>
      <div class="form-group row" v-for="(f, i) in searches" :key="i">
        <label class="col-sm-12 col-form-label pd-y-0 tx-color-03">{{
          f.title
        }}</label>
        <div v-if="f.flag == 1" class="col-12 pd-y-0">
          <input
            v-model="$data['filterModel'][f.field]"
            type="text"
            class="form-control ht-30"
            :placeholder="`${f.title} бичнэ үү`"
          />
        </div>
        <loc-type-cascader
          v-else-if="f.flag == 3"
          :locTypekey="f.key"
          v-model="$data['filterModel'][f.field]"
          size="small"
          :disableAdd="true"
          class="wd-100p col-12 pd-y-0"
        />
        <div v-else-if="f.flag == 6" class="wd-100p col-12 pd-y-0">
          <DatePicker
            v-model="$data['filterModel'][f.field]"
            placeholder="Огноо сонгоно уу"
            type="date"
            size="mini"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </div>
        <div v-else class="col-12 pd-t-0">
          {{ f.flag }}
        </div>
      </div>
    </form>
    <div class="btn-group">
      <button
        @click="$emit('on-search', filterModel)"
        class="btn btn-xs btn-outline-light"
      >
        Хайх
      </button>
      <button @click="$emit('on-reset')" class="btn btn-xs btn-outline-light">
        Бүгд
      </button>
    </div>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    DatePicker,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    searches: {
      type: Array,
      default: () => []
    },
    allCount: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      filterModel: {
        task: "",
        systemFlag: null
      }
    };
  }
};
</script>

<style></style>
